import React from "react";

import TransferTrackerTimeline from "./TransferTrackerTimeline";

function formatStepTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function buildTrackerSteps(status, { sentAt, settledAt }) {
  const s = String(status || "").toUpperCase();
  const rejected = s === "CANCELLED" || s === "REJECTED";
  const fulfilled = s === "COMPLETED" || s === "PARTIALLY_COMPLETED";
  const pending = s === "PENDING";

  const sentTime = formatStepTime(sentAt);
  const settledTime = formatStepTime(settledAt);

  const step1 = {
    key: "sent",
    title: "Offer sent",
    detail: sentTime
      ? `Sent on ${sentTime}`
      : "Your NAV-locked offer was submitted to the platform.",
    state: "complete",
  };

  let step2;
  if (rejected) {
    step2 = {
      key: "accept",
      title: s === "CANCELLED" ? "Offer withdrawn" : "Offer not completed",
      detail:
        s === "CANCELLED"
          ? "You cancelled this offer before the recipient accepted."
          : "The recipient did not complete this transfer.",
      state: "failed",
    };
  } else if (fulfilled) {
    step2 = {
      key: "accept",
      title: "Recipient accepted",
      detail: "Offer accepted at the locked NAV.",
      state: "complete",
    };
  } else {
    step2 = {
      key: "accept",
      title: "Awaiting recipient",
      detail: "Review and acceptance pending. Your shares stay in your name until then.",
      state: pending ? "current" : "upcoming",
    };
  }

  let step3;
  if (rejected) {
    step3 = {
      key: "settled",
      title: "Settlement",
      detail: "No settlement — this offer did not complete.",
      state: "skipped",
    };
  } else if (fulfilled) {
    step3 = {
      key: "settled",
      title: "Settlement complete",
      detail: settledTime
        ? `Completed on ${settledTime}`
        : "Shares transferred and cash settlement recorded.",
      state: "complete",
    };
  } else {
    step3 = {
      key: "settled",
      title: "Settlement",
      detail: "After acceptance, shares move and prefunded settlement is finalized.",
      state: "upcoming",
    };
  }

  return [step1, step2, step3];
}

/** Sender-side transfer offer tracking (vertical timeline). */
export default function TransferProgressSteps({ status, sentAt, settledAt }) {
  const steps = buildTrackerSteps(status, { sentAt, settledAt });
  return <TransferTrackerTimeline steps={steps} ariaLabel="Transfer tracking" />;
}
